<template>
  <div class="home" id="home">
    <div class="head">
      <div class="logo">
        <div class="logo_left">
          <!--          <img src="./img/square.png" alt="">-->
          MJ绘画
        </div>
        <div class="logo_right">
          让创意充满无限可能
        </div>
      </div>

      <div class="head_list">
        <div class="left_t">
          <a href="/" target="_blank">首页</a>
          <div class="line"></div>
        </div>
        <div class="left_m">
          <a href="/" target="_blank">绘画广场</a>
          <!--          <p>绘画广场</p>-->
          <div class="line"></div>
        </div>
        <div class="left_m">
          <a href="https://www.midjournny.cn/mjhelp/index.html" target="_blank">MJ教程</a>
          <!--          <p>MJ教程</p>-->
          <div class="line"></div>
        </div>
      </div>
      <div class="start">
        <a href="/">
          <div>
            <span>开始创作</span>
          </div>
        </a>
      </div>
      <div class="login">
        <a href="/">注册/登录</a>
      </div>
    </div>

    <div class="represent">
      <div class="top_container">
        <div class="index_title">
          <span class="ai">MJ</span>绘画
          <p>轻松创作 极速出图</p>
        </div>
        <div class="tags">
          <div class="tag-item flex-center">
            <img src="./img/home_icon_1.png" alt="">
            <span>快速</span>
          </div>
          <div class="tag-item flex-center">
            <img src="./img/home_icon_2.png" alt="">
            <span>稳定</span>
          </div>
          <div class="tag-item flex-center">
            <img src="./img/home_icon_3.png" alt="">
            <span>原创</span>
          </div>
        </div>
        <h2 class="top_description">
          基于最新AI技术，可快速生成各种风格的高质量图片，赶快来体验吧！
        </h2>
        <a href="/" class="create_btn flex-center curpoint">
          开始创作
        </a>
      </div>
      <div class="top_bg">
        <div class="el-image">
          <img class="" src="./img/home-bg.png" alt="">

        </div>
      </div>
    </div>
    <div class="attempt">
      <a href="/mj"> <img src="./img/home_icon_4.png" alt=""><span>尝试创作&nbsp;&nbsp;&nbsp; >></span></a>
    </div>

    <div class="recommend_main">
      <h2 class="text_tit1">优秀AI智能绘画推荐</h2>
      <p class="text_tit2">Excellent intelligent recommendation</p>
      <div class="image_wrapper_container">
        <div class="image_wrapper">
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_01.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_02.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_03.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_04.png" alt="" class="el-image__inner">
            </div>
          </div>
        </div>
        <div class="image_wrapper">
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_05.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_06.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_07.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_08.png" alt="" class="el-image__inner">
            </div>
          </div>
        </div>
        <div class="image_wrapper">
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_09.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_10.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_11.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_12.png" alt="" class="el-image__inner">
            </div>
          </div>
        </div>
        <div class="image_wrapper">
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_13.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_14.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_15.png" alt="" class="el-image__inner">
            </div>
          </div>
          <div class="image_item">
            <div class="el-image">
              <img src="./img/home_img_16.png" alt="" class="el-image__inner">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index_bottom_card">
      <div class="start-create-card">
        <div class="top_container">
          <div class="index_title text-26 sm:text-30 lg:text-46">
            <div>
              <span class="ai">MJ</span>绘画
            </div>
            <div>
              <p>轻松创作 极速出图</p>
            </div>
          </div>
          <div class="tags">
            <div class="tag-item flex-center">
              <img src="./img/home_icon_1.png" alt="">
              <span>快速</span>
            </div>
            <div class="tag-item flex-center">
              <img src="./img/home_icon_2.png" alt="">
              <span>稳定</span>
            </div>
            <div class="tag-item flex-center">
              <img src="./img/home_icon_3.png" alt="">
              <span>原创</span>
            </div>
          </div>
          <h2 class="top_description text-12 sm:text-13 lg:text-13">
            基于最新AI技术，可快速生成各种风格的高质量图片，赶快来体验吧！
          </h2>
          <a href="/" class="create_btn flex-center curpoint">
            开始创作
          </a>
        </div>
        <div class="top_bg">
          <div class="el-image">
            <img src="./img/home-bg.png" alt="" class="el-image__inner"></div>
        </div>
      </div>
    </div>

    <div class="base-view">
      <div class="logo-card">
        <img src="./img/square.png" loading="lazy" class="logo">
        <div class="title-info">
          MJ绘画
        </div>
      </div>
      <div class="menu-card">
        <div class="menu-title">
          创作
        </div>
        <a href="/square" class="menu-item">
          首页
        </a><a href="/square" class="menu-item">
        绘画广场
      </a>
        <a href="/mj" class="menu-item">
          AI创作
        </a></div>
      <div class="menu-card">
        <div class="menu-title">
          服务
        </div>
        <a href="/member" class="menu-item">
          会员套餐
        </a><a href="https://www.midjournny.cn/mjhelp/index.html" class="menu-item">
        平台教程
      </a><a href="https://docs.qq.com/doc/p/d5bc65c646ea1d70ec02ac7884c76ed274369512" target="_blank"
             class="menu-item">
        隐私政策
      </a><a href="https://docs.qq.com/doc/p/dab4e5845c5a3a8aadc6556fe9f6cc7803b7cb9b" target="_blank"
             class="menu-item">
        用户协议
      </a></div>
      <div class="contact-card">
        <div class="menu-title">
          联系我们
        </div>
        <div class="contact-img"><img src="./img/home_kefu.png" loading="lazy" class="logo"
        ></div>
      </div>
    </div>
    <div class="keeponrecord">
      MJ绘画 {{GA_BEI_AN_CODE}} <a target="_blank" href="https://beian.miit.gov.cn/">{{BEI_AN_CODE}}
    </a>
    </div>

  </div>

</template>
<script type="text/ecmascript-6">

export default {

  data() {
    return {
      GA_BEI_AN_CODE:GA_BEI_AN_CODE,
      BEI_AN_CODE:BEI_AN_CODE
    }
  }

}


</script>

<style rel="stylesheet/scss" lang="scss">

#home {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-size: 14px;
  color: #fff;
  background-color: #0e0e0e;
  overflow-y: auto;

  .head {
    display: flex;
    justify-content: space-evenly;
    padding: 15px 0;
    position: relative;

    .logo {
      font-size: 16px;
      display: flex;
      //align-items: center;
      .logo_left {
        display: flex;
        align-items: center;
        font-weight: 700;
      }

      .logo_right {
        width: 130px;
        font-size: 12px;
        color: #7d7d7d;
        margin-left: 15px;
        padding-top: 18px;

      }

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
      }
    }

    .head_list {
      z-index: 999;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 700;

      .left_t {
        margin-right: 30px;
        cursor: pointer;

        a {
          color: white;
        }

        .line {
          border-radius: 3px;
          height: 3px;
          margin-top: 3px;
          width: 27px;
          background: linear-gradient(90deg, #8d28fc, #0afdec);
        }
      }

      .left_m {
        margin-right: 30px;
        color: #FFFFFF99;
        cursor: pointer;

        a {
          color: #FFFFFF99;
        }

        .line {
          border-radius: 3px;
          height: 3px;
          margin-top: 3px;
          width: 27px;
          background: #8d28fc00;
        }
      }

    }

    .start {
      margin-right: 190px;
      display: flex;
      position: relative;
      z-index: 2;

      a {
        animation: move-ab 5s infinite alternate;
        align-items: center;
        display: flex;
        background: linear-gradient(90deg, #8d28fc, #0afdec, #0afdec, #8d28fc);
        background-size: 400%;
        border-radius: 50px;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 16px;
        padding: 4px;
        text-align: center;
        text-decoration: none;
        transform: translate(0);
        width: 142px;
        z-index: 1;

      }

      a:before {
        animation: move-ab 5s infinite alternate;
        background: linear-gradient(90deg, #8d28fc, #0afdec, #0afdec, #8d28fc);
        background-size: 400%;
        border-radius: 50px;
        bottom: -2px;
        content: "";
        filter: blur(5px);
        left: -2px;
        position: absolute;
        right: -2px;
        top: -2px;
        z-index: -1;
      }

      div {

        background: #000;
        border-radius: 38px;
        font-weight: 700;
        height: 38px;
        width: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
      }

      span {
        -webkit-font-smoothing: antialiased;
        -webkit-text-fill-color: transparent;
        background: linear-gradient(90deg, #0afdec, #8d28fc);
        -webkit-background-clip: text;
        font-size: 16px;
      }


    }

    .login {
      margin-left: auto;
      position: absolute;
      right: 35px;
      top: 18px;
      align-items: center;
      border-radius: 80px;
      color: #fff;
      cursor: pointer;
      display: flex;
      font-size: 16px;
      height: 40px;
      opacity: 1;
      background: hsla(0, 0%, 100%, .11);
      padding-left: 35px;
      padding-right: 35px;
      z-index: 9;
      a{
        color: white;
      }
    }

  }

  .represent {
    margin: 0 auto;
    max-width: 1200px;
    position: relative;
    width: 100%;

    .top_container {
      padding: 60px 24px 140px;
      position: relative;
      z-index: 2;

      .index_title {
        color: #fff;
        display: inline-block;
        font-size: 46px;
        font-weight: 700;
        letter-spacing: 3px;

        .ai {
          background: linear-gradient(90deg, #8d28fc, #0afdec);
          -webkit-font-smoothing: antialiased;
          -webkit-text-fill-color: transparent;
          -webkit-background-clip: text;
        }
      }

      .tags {
        align-items: center;
        display: flex;
        gap: 12px;
        margin-top: 16px;

        .tag-item {
          background: hsla(0, 0%, 100%, .1);
          border-radius: 8px;
          height: 30px;
          width: 72px;
          justify-content: center;
          align-items: center;
          display: flex;

          img {
            height: 11px;
            width: 11px;
          }

          span {
            color: #fff;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 1px;
            margin-left: 8px;
            text-shadow: 0 3px 6px rgba(0, 0, 0, .2);
          }

        }
      }

      .top_description {
        color: #fff;
        font-size: 13px;
        font-weight: 400;
        line-height: 21px;
        margin-top: 1.25vw;
        max-width: 240px;
      }

      .create_btn {
        animation: move-ac 5s infinite alternate;
        //background-image: linear-gradient(90deg, #0afdec, #8d28fc);
        background: linear-gradient(90deg, #0afdec, #8d28fc);

        border-radius: 10px;
        box-shadow: 0 4px 10px 0 rgba(141, 40, 252, .3);
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        height: 45px;
        letter-spacing: 2px;
        line-height: 16px;
        margin-top: 20px;
        max-width: 220px;
        text-align: left;
        white-space: nowrap;
        width: 100%;
        position: relative;
      }

      .create_btn:before {
        animation: move-ab 5s infinite alternate;
        background: linear-gradient(90deg, #8d28fc, #0afdec, #0afdec, #8d28fc);
        background-size: 400%;
        border-radius: 10px;
        bottom: -2px;
        content: "";
        filter: blur(5px);
        left: -2px;
        position: absolute;
        right: -2px;
        top: -2px;
        z-index: -1;
      }
    }

    .top_bg {
      max-width: 800px;
      position: absolute;
      right: 0;
      top: -50px;
      width: 100%;
      z-index: 1;

      .el-image {
        display: inline-block;
        overflow: hidden;
        position: relative;
z-index: -999;
        .el-image__inner {
          vertical-align: top;
          z-index: -999;
        }
      }
    }

  }

  .attempt {
    background-color: #151515;
    width: 100%;
    padding: 20px 0;

    a {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    span {
      word-wrap: break-word;
      color: #fff;
      display: inline-block;
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
      margin-left: 6px;
      text-align: left;
      white-space: nowrap;

    }
  }

  .recommend_main {

    margin: 32px auto 0;
    max-width: 1200px;
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;

    .text_tit1 {
      word-wrap: break-word;
      -webkit-text-fill-color: transparent;
      -webkit-background-clip: text;
      background-image: linear-gradient(90deg, #0afdec, #9e0eff 96.428573%);
      display: inline-block;
      font-size: 24px;
      font-weight: 700;
      line-height: 26px;
      text-align: left;
      white-space: nowrap;
    }

    .text_tit2 {
      word-wrap: break-word;
      -webkit-text-fill-color: transparent;
      -webkit-background-clip: text;
      background-image: linear-gradient(90deg, #0cfbec, #9d11ff);
      font-size: 12px;
      font-weight: 700;
      line-height: 14px;
      margin-top: 10px;
      text-align: center;
      white-space: nowrap;
    }

    .image_wrapper_container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 40px;

      .image_wrapper {
        width: 22%;

        .image_item {
          font-size: 0;
          width: 100%;

          .el-image {
            display: inline-block;
            overflow: hidden;
            position: relative;

            img {
              margin: 0;
              -o-object-fit: contain;
              object-fit: contain;
              padding: 0 5px 10px;
              width: 100%;
            }
          }
        }
      }
    }
  }

  .index_bottom_card {
    margin-top: 32px;

    .start-create-card {
      margin: 0 auto;
      max-width: 1200px;
      position: relative;
      width: 100%;
      overflow: hidden;

      .top_container {
        align-items: center;
        display: flex;
        flex-direction: column;
        padding: 60px 24px 140px;
        position: relative;
        z-index: 2;

        .index_title {
          color: #fff;
          display: flex;
          font-size: 46px;
          font-weight: 700;
          letter-spacing: 3px;
          flex-direction: column;
          align-items: center;

          .ai {
            -webkit-text-fill-color: transparent;
            background: linear-gradient(90deg, #8d28fc, #0afdec);
            -webkit-background-clip: text;
          }
        }

        .tags {
          align-items: center;
          display: flex;
          gap: 12px;
          margin-top: 16px;

          .tag-item {
            background: hsla(0, 0%, 100%, .1);
            border-radius: 8px;
            height: 30px;
            width: 72px;
            justify-content: center;
            align-items: center;
            display: flex;

            img {
              height: 11px;
              width: 11px;
            }

            span {
              color: #fff;
              font-size: 12px;
              font-weight: 400;
              letter-spacing: 1px;
              margin-left: 8px;
              text-shadow: 0 3px 6px rgba(0, 0, 0, .2);
            }
          }
        }

        .top_description {
          color: #fff;
          font-size: 13px;
          font-weight: 400;
          line-height: 21px;
          margin-top: 1.25vw;
          max-width: 240px;
        }

        .create_btn {
          max-width: 220px;
          background-image: linear-gradient(90deg, #0afdec, #8d28fc);
          border-radius: 10px;
          box-shadow: 0 4px 10px 0 rgba(141, 40, 252, .3);
          color: #fff;
          font-size: 16px;
          font-weight: 700;
          height: 45px;
          letter-spacing: 2px;
          line-height: 16px;
          margin-top: 20px;
          max-width: 220px;
          text-align: left;
          white-space: nowrap;
          width: 100%;
        }
      }

      .top_bg {
        max-width: 800px;
        opacity: .5;
        position: absolute;
        right: 50%;
        top: 0;
        transform: translateX(50%);
        width: 100%;

        .el-image {
          display: inline-block;
          overflow: hidden;
          position: relative;

          .el-image__inner {
            vertical-align: top;
          }
        }
      }
    }
  }

  .base-view {
    display: none;
    //display: flex;
    justify-content: center;
    align-items: flex-start;
    height: 358px;
    width: 100%;

    .logo-card {
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-right: 142.5px;
      margin-top: 139px;

      .logo {
        border-radius: 22px;
        height: 44px;
        overflow: hidden;
        width: 44px;
      }

      .title-info {
        color: #fff;
        font-size: 22px;
        margin-top: 14px;
      }
    }

    .menu-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 230px;
      margin-top: 66px;

      .menu-title {
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 29px;
      }

      .menu-item {
        color: #d3d3d3;
        cursor: pointer;
        font-size: 14px;
        z-index: 1;
        margin-bottom: 20px;
        touch-action: manipulation;
      }
    }

    .contact-card {
      margin-top: 66px;

      .menu-title {
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 26px;
      }

      .contact-img {
        background-color: #fff;
        height: 170px;
        width: 170px;
      }
    }
  }

  .keeponrecord {
    color: #6d6d6d;
    margin: 0 auto;
    padding: 20px 0;
    text-align: center;
    font-size: 12px;

    a {
      color: #6d6d6d;
    }
  }

}

@keyframes move-ab {
  from {
    background-position: -400% 0;
  }
}

@keyframes move-ac {
  from {
    background-position: -400% 0;
  }
}

</style>